import { TableRow, TableCell } from "@material-ui/core"
import {
  getDataEditPenjualan,
  RenderStatusPembelian,
} from "App/Component/layout/Penjualan/DaftarPenjualan/helpers"
import {
  changeActiveMenu,
  changeActiveTab,
  changePagePropsInputPenjualan,
} from "App/Component/layout/Wrapper/context/actions"
import { TableAction, Loading } from "App/Component/ui"
import { getComparator, stableSort } from "App/Component/ui/datatable/utils"
import { BILLING_INPUT_PENJUALAN } from "App/constants"
import { useDatatables } from "App/hooks"
import {
  defaultDateDisplay,
  formatNumber,
  isNull,
  scrollToTop,
} from "App/utils/helpers"
import { FreezeTableClient } from "components/organism"
import { useDispatchWrapper } from "hooks"
import React, { useContext, useEffect, useState } from "react"
import { FormContext } from "../../context/FormContext"
import { headCells } from "./helpers"
import useMutationDiskon from "App/Component/layout/Penjualan/InputPenjualan/ui/hooks/useMutationDiskon"

function TabPenjualan({ setNewData, rows, loading }) {
  const { formData } = useContext(FormContext)

  useEffect(() => {
    ;(async () => {
      await setNewData()
    })()
  }, [formData.tagihan_id]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <Loading show={loading} />
      <TableTabPenjualan rows={rows} />
    </>
  )
}

export const TableTabPenjualan = ({
  rows,
  inTabExternal = false,
  clickDelete,
}) => {
  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: rows,
    orderByDefault: "id",
    orderByRow: ["id"],
  })

  const [loading, setLoading] = useState(false)
  const { dispatch, handleClickMenu } = useDispatchWrapper()
  const { getDiskon } = useMutationDiskon()

  const handleClickUpdate = async (row) => {
    setLoading(true)
    const diskon = await getDiskon(row.id_type_of_care, row.insurance_id)

    Promise.resolve()
      .then(() => {
        dispatch(changeActiveMenu(BILLING_INPUT_PENJUALAN))
      })
      .then(async () => {
        const propsPageInputPenjualan = await getDataEditPenjualan(
          row,
          "tagihanId",
          diskon,
        )

        scrollToTop()
        dispatch(changePagePropsInputPenjualan(propsPageInputPenjualan))
        dispatch(changeActiveTab(BILLING_INPUT_PENJUALAN))

        handleClickMenu({
          code: BILLING_INPUT_PENJUALAN,
          name: "Input Penjualan",
        })

        setLoading(false)
      })
  }

  return (
    <>
      <Loading show={loading} />
      <FreezeTableClient
        title={
          inTabExternal
            ? "DAFTAR PENJUALAN"
            : "DAFTAR PENJUALAN BERDASAKAN KUNJUNGAN"
        }
        setQ={setQ}
        withExportButton={false}
        order={order}
        orderBy={orderBy}
        handleRequestSort={handleRequestSort}
        length={length}
        rows={rows}
        headCells={headCells}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
      >
        {stableSort(data, getComparator(order, orderBy))
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((row, index) => {
            const totalPenjualan =
              row.harga_total_barang +
              row.harga_total_jasa +
              row.harga_total_fasilitas +
              row.harga_total_rikjang +
              row.harga_total_paket
            return (
              <TableRow hover key={index}>
                <TableCell scope="row" padding="none" align="center">
                  {index + 1}
                </TableCell>
                <TableCell scope="row" padding="none">
                  {inTabExternal ? (
                    <TableAction
                      isUpdate={false}
                      clickDelete={() => clickDelete(row)}
                    />
                  ) : (
                    <TableAction
                      isDelete={false}
                      isUpdate={false}
                      isSelect={true}
                      clickSelect={() => handleClickUpdate(row)}
                    />
                  )}
                </TableCell>
                <TableCell align="left" width={"5%"}>
                  {row?.id}
                </TableCell>
                <TableCell align="left" width={"10%"}>
                  {row?.id_kunjungan}
                </TableCell>
                <TableCell align="left" width={"10%"}>
                  {row?.tagihanId}
                </TableCell>
                <TableCell align="left">{row.namaGudang}</TableCell>
                <TableCell align="left">{row.jenisLayanan}</TableCell>
                <TableCell align="left">
                  {isNull(row.date) ? "" : defaultDateDisplay(row.date)}
                </TableCell>
                <TableCell align="left">
                  <RenderStatusPembelian status={row.status_transaksi} />
                </TableCell>
                <TableCell align="left">{row.namaRM}</TableCell>
                <TableCell align="left">{row.idRM}</TableCell>
                <TableCell align="right">
                  {formatNumber(totalPenjualan)}
                </TableCell>
                <TableCell align="right">
                  {formatNumber(row.jumlah_set_discount)}
                </TableCell>
                <TableCell align="right">
                  {formatNumber(row.jumlah_tax)}
                </TableCell>
                <TableCell align="right">
                  {formatNumber(row.total_Penjualan)}
                </TableCell>{" "}
                <TableCell align="right">
                  {formatNumber(row.bayar_jual)}
                </TableCell>
                <TableCell align="right">{formatNumber(row.sisa)}</TableCell>
              </TableRow>
            )
          })}
      </FreezeTableClient>
    </>
  )
}

export default TabPenjualan
